import axios from 'axios';
import API_URL from '../config/api';

// Create axios instance with auth interceptor
export const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('armita_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('armita_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const getAuthHeaders = () => {
  const token = localStorage.getItem('armita_token');
  if (!token) return {};
  return {
    'Authorization': `Bearer ${token}`
  };
};

export const authFetch = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;

  const headers = {
    ...getAuthHeaders(),
    ...options.headers
  };

  const response = await fetch(url, {
    ...options,
    headers
  });

  if (response.status === 401) {
    localStorage.removeItem('armita_token');
    window.location.href = '/login';
    throw new Error('Session expired. Please login again.');
  }

  return response;
};

export const apiGet = async (endpoint) => {
  const response = await authFetch(endpoint);
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
};

export const apiPost = async (endpoint, data) => {
  const response = await authFetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
};

export const apiUpload = async (endpoint, formData) => {
  const response = await authFetch(endpoint, {
    method: 'POST',
    body: formData
  });
  if (!response.ok) {
    throw new Error(`Upload error: ${response.status}`);
  }
  return response.json();
};
